import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  root: (props) => ({
    width: `${props.width}vw`,
    height: `${props.height}rem`,
    maxWidth: `${props.maxWidth}rem`,
    maxHeight: `${props.maxHeight}rem`,
    paddingLeft: `${props.paddingLeft}rem`,
    paddingRight: `${props.paddingRight}rem`,
  }),
  title: (props) => ({
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: `${props.paddingHeaderTop}rem`,
    paddingBottom: `${props.paddingHeaderBottom}rem`,
  }),
  logo: (props) => ({
    maxHeight: `${props.sizeHeader}rem`,
  }),
});

export default useStyles;
